import { Injectable } from '@angular/core';
import { SearchAbstractResource } from './search.abstract.resource';
import { DialPlanManagementGroupSearchResult } from '../../../shared/models/generated/ziroModels';
import { Observable } from 'rxjs';

export class SearchDialPlanQueryParams {
  q?: string;
  name?: string;
  extension?: string;
}

@Injectable()
export class SearchDialPlanResource extends SearchAbstractResource {
  get(params: SearchDialPlanQueryParams): Observable<DialPlanManagementGroupSearchResult[]> {
    return this.search<DialPlanManagementGroupSearchResult[]>('/services/cisco/admin/dial-plan/groups/search', params);
  }
}
